<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { db } from "../firebase/firebase";

export default {
  created() {
    const title = this.getTitle(this);
    if (title) {
      document.title = title;
    }
  },
  computed: {
    ...mapGetters([
      "loading",
      "user",
      "userId",
      "userEmail",
      "userName",
      "error",
      "userIsCheckedIn",
      "status",
      "userIsAdmin",
    ]),
    redirectHost() {
      return process.env.VUE_APP_REDIRECT_HOST;
    },
    localBase() {
      return "http://localhost:5001/virtual-house-pro-staging/us-central1";
    },
    prodBase() {
      return "https://us-central1-virtual-house-pro.cloudfunctions.net";
      // return "http://localhost:5001/virtual-house-pro-staging/us-central1";
    },
  },
  data: () => ({
    currentUser: "",
  }),
  firestore() {
    return {
      users: db.collection("users"),
    };
  },
  methods: {
    getTitle(vm) {
      const { title } = vm.$options;
      if (title) {
        return typeof title === "function" ? title.call(vm) : title;
      }
    },
    convertToDateString(value) {
      const momentObj = moment(value, "dddd MMMM Do, YYYY");
      return momentObj.format("MM-DD-YYYY");
    },
    convertToDate(day) {
      const momentObj = moment(day.date, "MM-DD-YYYY");
      return momentObj.format("dddd MMMM Do, YYYY");
    },
    joinDateAndTime(day, slot) {
      const momentObj = moment(day.date, "MM-DD-YYYY");
      const timeSlot = slot.starts_at;
      return `${momentObj.format("dddd MMMM Do, YYYY")} at ${timeSlot}`;
    },
    checkisAdmin() {
      if (this.user) {
        this.$firestore.users
          .doc(this.user)
          .get()
          .then((doc) => {
            this.currentUser = doc.data();
          })
          .then(() => {
            this.$store.dispatch("checkCurrentUserIsAdmin");
          });
      }
    },
    navigateTo(path) {
      if (this.$route.path !== path) this.$router.push(path).catch(() => {});
    },
    getCookie(name) {
      const cookieArr = document.cookie.split(";");
      for (let i = 0; i < cookieArr.length; i++) {
        const cookiePair = cookieArr[i].split("=");
        if (name == cookiePair[0].trim()) {
          return decodeURIComponent(cookiePair[1]);
        }
      }
      return null;
    },
    signUpWithFirebase(email, password) {
      const user = {
        email,
        password,
      };
      this.$store
        .dispatch("signUpAction", user)
        .then(() => {
          this.navigateTo("home");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    signInWithFirebase(email, password) {
      const user = {
        email,
        password,
      };
      this.$store
        .dispatch("signInAction", user)
        .then(() => {
          if (this.$store.getters.userIsAdmin) {
            this.navigateTo("admin");
          } else {
            this.navigateTo("home");
          }
        })
        .catch((err) => {
          this.$store.commit("setError", err);
        });
    },
    signInWithProviderRedirect() {
      this.$store
        .dispatch("signInWithProviderRedirect")
        .then(() => {
          this.navigateTo("home");
        })
        .catch((err) => this.$store.commit("setError", err));
    },
    signOutWithFirebase() {
      this.$store.dispatch("signOutAction");
      this.navigateTo("home");
    },
  },
  filters: {
    firstName: function (value) {
      if (!value) return "";
      value = value.toString().split(" ");
      return value[0];
    },
    firstLetter: function (value) {
      if (!value) return "";
      value = value.toString().charAt(0);
      return value[0];
    },
    capitalizeFirstLetter: function (value) {
      if (!value) return "";
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    toDollar: function (value) {
      if (!value) return "";
      let dollars = value / 100;
      dollars = dollars.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
      return dollars;
    },
  },
};
</script>
